import * as moment from 'moment';
import { DateConverter } from 'src/app/core/services/mapper/converters';

export class DashBoardInventaire {
    static jsonMap = {
        dateDeclaration: { key: 'dateDeclaration', converter: new DateConverter() },
        raisonSocialeEntreprise: 'raisonSocialeEntreprise'
    };

    dateDeclaration: moment.Moment;
    raisonSocialeEntreprise: string;
}
